//import logo from "./logo.svg";
import React, { useState, useRef, useEffect } from "react";

import "./App.css";

function App() {
  return (
    <div className="homebanner">
      <div className="bannerbox">
        <h1>Find your new best friend!</h1>
        <a href="/search">Click to start!</a>
      </div>
    </div>
  );
}

export default App;
